export default __webpack_public_path__ + "static/media/5.aa1b953b.svg";